import React from 'react'
import Eula from '../eula'

const EulaNo = () => {
    return <Eula languageCode="no" />
}

export default EulaNo
